<span #stickyPopover="stickyPopover"
     [stickyPopover]="popContent"
     [popoverTitle]="popTitle"
     [autoClose]="false"
     [animation]="false"
     popoverClass="splat-popover"
     container="body"
     triggers="manual"
     placement="auto">
</span>

<ng-template #popTitle>
  <i class="fa-thin fa-atom-simple me-1"></i>Splat details
</ng-template>

<ng-template #popContent>
  <ul class="list list-unstyled mb-0">
    <li><strong>Species</strong>: {{splat.description}}</li>
    <li><strong>Name</strong>: {{splat.name}}</li>
    <li><strong>Transition</strong>: {{splat.transition}}</li>
    <li><strong>Frequency</strong>: {{splat.frequency | number}} GHz</li>
    <li><strong>Redshifted frequency</strong>: {{splat.redshiftFrequency | number }} GHz</li>
  </ul>
</ng-template>
